import { useState } from 'react';
import { faqItems } from '@/mocks/haijiao';

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <p className="text-sm font-semibold tracking-widest text-accent-600">常见问答</p>
          <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-foreground-950 md:text-4xl">
            先把疑问说清楚
          </h2>
        </div>

        <div className="mt-10 space-y-3">
          {faqItems.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  open ? 'border-primary-200 bg-background-100/70' : 'border-background-200 bg-background-50'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                >
                  <span className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                    {f.q}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-2xl text-foreground-400 transition-transform duration-300 ${
                      open ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}